var map = {
	"./blogger.svg": 5404,
	"./delicious.svg": 4441,
	"./digg.svg": 292,
	"./evernote.svg": 2716,
	"./linkedin.svg": 7616,
	"./lj.svg": 4343,
	"./messenger.svg": 3123,
	"./moimir.svg": 1618,
	"./odnoklassniki.svg": 1678,
	"./pinterest.svg": 2242,
	"./pocket.svg": 3433,
	"./qzone.svg": 3664,
	"./reddit.svg": 7067,
	"./renren.svg": 9922,
	"./sinaWeibo.svg": 4537,
	"./skype.svg": 4818,
	"./surfingbird.svg": 206,
	"./telegram.svg": 1338,
	"./tencentWeibo.svg": 296,
	"./tumblr.svg": 1121,
	"./twitter.svg": 8910,
	"./viber.svg": 4453,
	"./vkontakte.svg": 2224,
	"./whatsapp.svg": 6281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 359;